// @flow

import { getSession, getBroadcastSetting } from "./../graphql/queries";
import { onUpdateBroadcastSetting } from "../graphql/subscriptions";
import { API } from "aws-amplify";
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import FontPicker from "./FontPicker.react";
import Stack from "react-bootstrap/Stack";

import BroadcastScreenView from "./BroadcastScreenView.react";
import { useImperativeDisableScroll } from "../utils/util";

type Props = $ReadOnly<{
  sessionId: ?string,
}>;

export default function BroadcasterView(props: Props): React$Element<any> {
  const [sessionName, setSessionName] = useState("");
  const [broadcastSetting, setBroadcastSetting] = useState([]);

  useEffect(() => {
    fetchSession();
  }, [props.sessionId]);

  useEffect(() => {
    fetchBroadcastSetting();
  }, []);

  // Subscribe to broadcast setting update
  useEffect(() => {
    const subscription = API.graphql({
      query: onUpdateBroadcastSetting,
      variables: {
        id: props.sessionId,
      },
    }).subscribe({
      next: () => {
        async function updateFetch() {
          const fetchedBroadcastSettings = await fetchBroadcastSetting();
          // setBroadcastSetting(fetchedBroadcastSettings);
        }
        updateFetch();
      },
      error: (error) => console.warn(error),
    });
    return () => {
      subscription.unsubscribe();
    };
  }, []);

  // Disable scroll
  useImperativeDisableScroll(document.body, true);

  async function fetchSession() {
    const apiData = await API.graphql({
      query: getSession,
      variables: {
        id: props.sessionId,
      },
    });
    setSessionName(apiData.data.getSession.name);
  }

  async function fetchBroadcastSetting() {
    const apiData = await API.graphql({
      query: getBroadcastSetting,
      variables: {
        id: props.sessionId,
      },
    });
    setBroadcastSetting(apiData.data.getBroadcastSetting);
  }

  if (props.sessionId == null) {
    return <div>Invalid Session</div>;
  }
  return (
    <>
      {/* <Container fluid> */}
      {/* <span style={{ position: "absolute", right: "0" }}>{sessionName}</span> */}
      <BroadcastScreenView
        sessionId={props.sessionId}
        backgroundColor={broadcastSetting.screenColor}
        backgroundOpacity={broadcastSetting.screenOpacity}
        borderOpacity={broadcastSetting.borderOpacity}
        font={broadcastSetting.subFont}
        fontSize={broadcastSetting.subSize}
        fontColor={broadcastSetting.subColor}
        lineHeight={broadcastSetting.subLineHeight}
        textBackgroundColor={broadcastSetting.subBackgroundColor}
        textBackgroundOpacity={broadcastSetting.subBackgroundOpacity}
        textShadowWidth={broadcastSetting.textShadowWidth}
        textShadowBlur={broadcastSetting.textShadowBlur}
        minSeconds={broadcastSetting.subMinDisplaySeconds}
        maxSeconds={broadcastSetting.subMaxDisplaySeconds}
        minSecondsTextLengthThreshold={
          broadcastSetting.subMinThresholdCharacters
        }
        maxSecondsTextLengthThreshold={
          broadcastSetting.subMaxThresholdCharacters
        }
        screenWidth={broadcastSetting.screenWidth}
        screenHeight={broadcastSetting.screenHeight}
        subAlign={broadcastSetting.subAlign}
        marginBottom={broadcastSetting.marginBottom}
        lineNumber={broadcastSetting.lineNumber}
        isNoWrap={broadcastSetting.isNoWrap}
        isDemoText={broadcastSetting.isDemoText}
      />
      {/* </Container> */}
    </>
  );
}
